import axios from 'axios'

export const getVersion = () => axios.get('/version.json', { params: { timestamp: Date.now() } })
